import React from 'react';
import { Button } from "@/components/ui/button";
import { useAuth } from '../../context/AuthContext'; // Adjust path if needed
import { LogOut } from 'lucide-react'; // Optional: Add an icon

export function LogoutButton() {
  const { signOut, loading } = useAuth();

  const handleLogout = async () => {
    const { error } = await signOut();
    if (error) {
      console.error('Error logging out:', error.message);
      // Optionally: Show error to user via toast or other means
    }
    // State update happens via AuthContext listener
  };

  return (
    <Button 
      variant="ghost" // Or another appropriate variant
      size="sm"       // Or another appropriate size
      onClick={handleLogout} 
      disabled={loading}
    >
      <LogOut className="mr-2 h-4 w-4" /> {/* Optional Icon */}
      {loading ? 'Logging out...' : 'Logout'}
    </Button>
  );
} 